
const DeleteButton = ({ onClick,label='Del',...props }) => {
    return (
        <div>
            <button type="button" onClick={onClick} {...props} className="btn m-1 btn-sm bg-danger">
                {label}
            </button>
        </div>
    );
};

export default DeleteButton;
